<template>  
  <div>
  	<div class="modalsave" v-show="saveConfig.capa"></div>
    <validation-observer v-slot="{ invalid }">
      <b-form  inline style="margin-bottom:15px" novalidate>
        <b-row style="width:100%" v-if="namePath==='admin_usuarios' && dataIndex[namePath]!==99999">
                <sw-inputs
                  inputTabla="list_users"
                  inputCampo="name"
                  :md="4"
                  :lg="4"
                  >
                </sw-inputs>
                <sw-inputs
                  inputTabla="list_users"
                  inputCampo="email"
                  :md="5"
                  :lg="5"

                  >
                </sw-inputs>
                <sw-inputs
                  inputTabla="list_users"
                  inputCampo="password"
                  :md="3"
                  :lg="3"
                  >
                </sw-inputs>
                <sw-inputs
                  style="margin-top:15px;margin-bottom:20px"
                  inputTabla="list_users"
                  inputCampo="admin"
                  :md="4"
                  :lg="4"
                  >
                </sw-inputs>
                <sw-inputs
                  style="margin-top:15px;margin-bottom:20px"
                  inputTabla="list_users"
                  inputCampo="permisos_delete"
                  :md="5"
                  :lg="5"
                  >
                </sw-inputs>
                <b-col class="pl-4 pr-4 pt-1" :md="12" :lg="12" v-for="(items,index) in permisosArray" :key="'arrayPermisos'+index" >
                  <h5  class="title-form  subtitle-form" style="margin: 20px -10px 0;">Permisos módulo {{items.modulos}} 
                        <b-form-checkbox
                          size="sm"
                          v-model="allSelected[items.modulos]"
                          :indeterminate="indeterminate"
                          aria-describedby="flavours"
                          aria-controls="flavours"
                          @input="toggleAll(allSelected[items.modulos],items.modulos)"
                        >
                          {{ allSelected[items.modulos] ? 'Deseleccionar Todos' : 'Seleccionar Todos' }}
                        </b-form-checkbox>
                    </h5>                  
                  <b-form-checkbox
                      style="display:inline-block;margin: 5px 10px"
                      v-for="(items2,index2) in items.permisos" :key="'arrayModulos'+index2"
                      v-model="permisosModulos[items.modulos][index2]"
                      name="checkbox-1"
                    >
                    {{index2}}
                  </b-form-checkbox>
                </b-col>
        </b-row>
        <b-row v-else>
          <b-col :md="4" :lg="4" >                       
            <b-form-group 
                label="Nombre usuario"
              >
              <validation-provider rules="required" immediate  v-slot="{ errors, required }"
              :name="'usuariosname'+user.id" style="position:relative"> 
                  <b-form-input
                    :id="'usuariosname'+user.id"
                    :name="'usuariosname'+user.id"
                    v-bind:class="{'is-invalid': veevalidateInputs(errors[0],'required',user.name)}"
                    :state="veevalidateInputs(errors[0],'required',user.name)"
                    size="sm"
                    :trim="true"
                    type="text"
                    v-model="user.name"
                    >
                  </b-form-input>
                  <small  class="text-danger input-errors">{{errors[0]}}</small>
              </validation-provider>
            </b-form-group>  
          </b-col>
          <b-col :md="4" :lg="4" >             
                <b-form-group 
                    label="Email"
                  >
                  <validation-provider rules="required" immediate  v-slot="{ errors, required }"
                  :name="'usuariosemail'+user.id" style="position:relative"> 
                      <b-form-input
                        :id="'usuariosemail'+user.id"
                        :name="'usuariosemail'+user.id"
                        v-bind:class="{'is-invalid': veevalidateInputs(errors[0],'required',user.email)}"
                        :state="veevalidateInputs(errors[0],'required',user.email)"
                        size="sm"
                        :trim="true"
                        type="email"
                        v-model="user.email"
                        >
                      </b-form-input>
                      <small  class="text-danger input-errors">{{errors[0]}}</small>
                  </validation-provider>
              </b-form-group>  
          </b-col>
          <b-col :md="4" :lg="4" class="sw-inputs">             
                <b-form-group 
                    label="Nueva Contraseña"
                  >
                  <validation-provider rules="" immediate  v-slot="{ errors, required }"
                  :name="'usuariospassword'+user.id" style="position:relative"> 
                      <b-form-input
                        :id="'usuariospassword'+user.id"
                        :name="'usuariospassword'+user.id"
                        size="sm"
                        :trim="true"
                        type="password"
                        v-model="password"
                        >
                      </b-form-input>
                      <small  class="text-danger input-errors">{{errors[0]}}</small>
                  </validation-provider>
              </b-form-group>  
          </b-col>
        </b-row>
      </b-form>
      <footer  v-if="namePath==='admin_usuarios' && dataIndex[namePath]!==99999" id="modal-1___BV_modal_footer_" class="modal-footer" style="margin: 0 -15px; padding: 0">
          <sw-saveform
            :index="dataIndex[namePath]"
            nameBtn="Usuario"
            :invalid="invalid"
            @save="saveUsuarios"
            >
          </sw-saveform>
      </footer>
      <footer  v-else id="modal-1___BV_modal_footer_" class="modal-footer" style="margin: 0 -15px; padding: 0">
          <sw-saveform
            :index="dataIndex[namePath]"
            nameBtn="Datos"
            :invalid="invalid"
            @save="saveUsuario"
            >
          </sw-saveform>
      </footer>
    </validation-observer>
  </div> 
</template>
<script>
import { mapState } from "vuex"
import { ValidationObserver } from 'vee-validate'
import { ValidationProvider } from 'vee-validate'
import SwInputs  from '@/components/forms/inputs.vue'
import SwSaveform from '@/components/forms/saveForm.vue'
export default 
{
  name: 'paciente',
  components: {
    SwInputs,
    ValidationObserver,
    SwSaveform,
    ValidationProvider        
  },
  data(){
    return {
      permisosArray: [ ],
      password: null, 
      datadataPost: {},
      allSelected: {},
      indeterminate: false
    }
  },
  props: {
  },  
  async created(){
    if(this.namePath==='admin_usuarios')
    {
      if(this.dataIndex[this.namePath]!==false)
      {
        await this.updateDataForm({state: 'list_users',data: this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].list_users})

      }  
      let permisosArray = []
      let datapermisosArray = Object.keys(this.permisosModulos)
      for (let i = 0; i < datapermisosArray.length; i++) {
        if(datapermisosArray[i]!=='configuracion')
        {
          this.permisosArray[i]={ modulos: '', permisos: {}}
          this.permisosArray[i].modulos=datapermisosArray[i] 
          this.allSelected[datapermisosArray[i]]=false
          permisosArray = Object.keys(this.permisosModulos[datapermisosArray[i]])  
          for (let j = 0; j < permisosArray.length; j++) {            
            this.permisosArray[i].permisos[permisosArray[j]]=false 
            if(this.dataIndex[this.namePath]!==false  && this.dataForm[this.namePath].list_users.permisos_modulos[datapermisosArray[i]]!==undefined &&  this.dataForm[this.namePath].list_users.permisos_modulos[datapermisosArray[i]][permisosArray[j]]!==undefined && this.dataForm[this.namePath].list_users.permisos_modulos[datapermisosArray[i]][permisosArray[j]]===true)  
            {
              this.permisosModulos[datapermisosArray[i]][permisosArray[j]]=true
            }                 
          } 
        }           
      }
      await this.updateDataForm({state: 'list_users/permisos_modulos', data: this.permisosModulos})
      await this.updateGlobal({state:'openModal/modal/loaded',data:true})
    }      
    else 
    {      
      await this.updateDataIndex({data: 99999})
      await this.updateGlobal({state:'openModal/modal/loaded',data:true})
    }
  },
  async beforeDestroy()
  {    
    if(this.namePath==='admin_usuarios')
    {
      this.resetDataIndex()
      this.resetConfig({state:'permisosModulos'})
      this.resetDataForm()
      this.resetDataPost()
    }
    else 
    {
      this.resetDataIndex()
    }
  },
	computed: {
		...mapState({ 
			permisosModulos   : state => state.configStore.permisosModulos,
		})
	},
  methods: {
    async saveUsuarios(event)
    {
      let nuevosPermisos={}
      let datapermisosArray = Object.keys(this.permisosModulos)
      for (let i = 0; i < datapermisosArray.length; i++) {
        nuevosPermisos [datapermisosArray[i]]= {}
        let datamodulosArray = Object.keys(this.permisosModulos[datapermisosArray[i]])
        for (let j = 0; j < datamodulosArray.length; j++) {
          if(this.permisosModulos[datapermisosArray[i]][datamodulosArray[j]])
          {
            nuevosPermisos [datapermisosArray[i]][datamodulosArray[j]]=true
          }          
        }
      }
      await this.updateDataForm({state: 'list_users/permisos_modulos', data: nuevosPermisos}) 
      this.$emit('save',{save: false, ftn: 'usuarioNuevoFtn' })
    },
    async saveUsuario()
    {
      await this.changeGlobal({state: 'saveConfig/capa', boolean: true})  
      if(this.password!==null)
      {
        this.datadataPost=
        { 
          data: [
            {list_users:
              {id: this.user.id, name: this.user.name, email: this.user.email, password: this.password}
            }],
          tablaAuditar: true,
          route: 'save_all',
          tablaDelete: [],
          notaDelete: null
        }
      }
      else 
      {
        this.datadataPost=
        { 
          data: [{list_users:{id: this.user.id, name: this.user.name, email: this.user.email}}],
          tablaAuditar: true,
          route: 'save_all',
          tablaDelete: [],
          notaDelete: null
        }        
      }    
      let promiseValues = await new Promise(async (resolve, reject) => {
      
         //   enviamos datos al backend  
          let promiseValue =  await this.saveAll(this.datadataPost).then( async (response) => {
              // aca lanzamos la notificacion y revisamos si hubo error o no y resolvemos		          
              this.saveNotify(response.data.error,'Datos guardados con éxito',false,false)		          
              if(response.data.error===false)
              {   				
                return response.data
              }
              return response.data.error						             
            }).catch(
            async (error) => {	 
              await this.changeGlobal({state: 'saveConfig/capa', boolean: false}) 
              this.saveNotify(true)	  	  
            //   aca manipulamos los datos del store despues del error   
            return error
            });	
            resolve(promiseValue)	         	
          });
				const await2 = this.resetDataIndex()
				const await3 = this.resetGlobal({state: 'openModal'})
        const await4 = this.resetGlobal({state: 'saveConfig/capa'})
        Promise.all([await2,await3,await4])
      
    },
    veevalidateInputs(rules,validate,value='')
    {
      if(validate!=='') 
      {
        if(['', null, undefined].indexOf(rules) === -1)
        {
          return false
        }
        return null
      }
      return null
    },
    async saveNotify(error,title=false,content=false,color=false)
		{
			try{				
				await this.changeGlobal({ state: 'saveConfig/notification/error', boolean: error})
				if(error) {
					await this.updateGlobal({ state: 'saveConfig/notification/title', data: 'No se guardaron los datos, intentalo de nuevo'})
				}
				if(content!==false) {
					await this.updateGlobal({ state: 'saveConfig/notification/content', data: content})
				}
				if(title!==false) {
					await this.updateGlobal({ state: 'saveConfig/notification/title', data: title})
				}
				const await1 =  this.updateGlobal({ state: 'saveConfig/notification/color', data: color})
				const await2 =  this.changeGlobal({ state: 'saveConfig/notification/view',  boolean: true})
				await await1
				await await2
				return !error
			}catch {

			}
		},
		toggleAll(checked,modulos) {
      let newValue=Object.keys(this.permisosModulos[modulos])
			for (let i = 0; i < newValue.length; i++) {
          this.permisosModulos[modulos][newValue[i]]=checked
			}
		},	
  }
}
</script>
<style>
</style>